"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tabs = require("../tabs/tabs");

var AddonPanel = function AddonPanel(_ref) {
  var panels = _ref.panels,
      onPanelSelect = _ref.onPanelSelect,
      selectedPanel = _ref.selectedPanel,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["panels", "onPanelSelect", "selectedPanel"]);
  return _react.default.createElement(_tabs.Tabs, (0, _extends2.default)({}, rest, {
    absolute: true,
    bordered: true,
    selected: selectedPanel,
    onSelect: onPanelSelect
  }), Object.entries(panels).map(function (_ref2) {
    var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
        k = _ref3[0],
        v = _ref3[1];

    return _react.default.createElement("div", {
      key: k,
      id: k,
      title: v.title
    }, v.render);
  }));
};

AddonPanel.propTypes = {
  selectedPanel: _propTypes.default.string,
  onPanelSelect: _propTypes.default.func.isRequired,
  panels: _propTypes.default.objectOf(_propTypes.default.shape({
    title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
    render: _propTypes.default.func
  })).isRequired
};
AddonPanel.defaultProps = {
  selectedPanel: null
};
var _default = AddonPanel;
exports.default = _default;